import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'payments',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: PaymentListComponent },
      { path: ':paymentId', component: PaymentDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class PaymentRoutingModule {}
